import { object, ref,string } from 'yup'

export const passwordRegex =
  // eslint-disable-next-line
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_\-+='";:<,>.?/{}\[\]`~\\|]).*(?=.*\d).{8,}$/

export const setPasswordSchema = object().shape({
  password: string()
    .required('Password is required')
    .matches(
      passwordRegex,
      'Incorrect password format (min 8 characters including lowercase and uppercase letter, number, special character)'
    ),
  repeatPassword: string()
    .required('Password is required')
    .matches(
      passwordRegex,
      'Incorrect password format (min 8 characters including lowercase and uppercase letter, number, special character)'
    )
    .oneOf([ref('password')], 'Passwords do not match')
})
